<form class="pt-2" [formGroup]="contactForm">
  <div class="flex flex-col md:flex-row gap-4 justify-between w-full mt-3">
    <div class="w-full md:w-[50%]">
      <label class="text-muted font-medium dark:text-[#A5A6A8]" for="firstname">
        {{ "Shared.First_Name" | translate }}
      </label>
      <input
        type="text"
        id="firstname"
        class="shared-input dark:text-white dark:bg-primary-dark"
        [ngClass]="{
          'is-invalid': isSubmitted && getControl('senderFirstName').invalid,
          'is-valid': isSubmitted && getControl('senderFirstName').valid
        }"
        placeholder="{{ 'Shared.First_Name_Placeholder' | translate }} "
        formControlName="senderFirstName"
      />

      @if(isSubmitted && getControl('senderFirstName').invalid){
      <div class="text-danger mt-1">
        @if (getControl('senderFirstName').errors?.['pattern']) {
        <small>{{ "Errors.Name_Error" | translate }}</small>
        }
      </div>
      }
    </div>
    <div class="w-full md:w-[50%]">
      <label class="text-muted font-medium dark:text-[#A5A6A8]" for="lastname">
        {{ "Shared.Last_Name" | translate }}
      </label>
      <input
        type="text"
        id="lastname"
        class="shared-input dark:text-white dark:bg-primary-dark"
        [ngClass]="{
          'is-invalid': isSubmitted && getControl('senderLastName').invalid,
          'is-valid': isSubmitted && getControl('senderLastName').valid
        }"
        placeholder=" {{ 'Shared.Last_Name_Placeholder' | translate }} 
                       "
        formControlName="senderLastName"
      />
      @if(isSubmitted && getControl('senderLastName').invalid){
      <div class="text-danger mt-1">
        @if (getControl('senderLastName').errors?.['pattern']) {
        <small>{{ "Errors.Name_Error" | translate }}</small>
        }
      </div>
      }
    </div>
  </div>

  <div class="flex flex-col md:flex-row gap-4 justify-between w-full mt-3">
    <div class="w-full md:w-[50%]">
      <label class="text-muted font-medium dark:text-[#A5A6A8]" for="email">
        {{ "Shared.Email" | translate }}
      </label>
      <input
        type="text"
        id="email"
        class="shared-input dark:text-white dark:bg-primary-dark"
        [ngClass]="{
          'is-invalid': isSubmitted && getControl('senderEmail').invalid,
          'is-valid': isSubmitted && getControl('senderEmail').valid
        }"
        placeholder=" {{
          'Shared.Email_Placeholder' | translate
        }}              "
        formControlName="senderEmail"
      />
      @if(isSubmitted && getControl('senderEmail').invalid){
      <div class="text-danger mt-1">
        @if (getControl('senderEmail').errors?.['pattern']) {
        <small>{{ "Errors.Email_Error" | translate }}</small>
        }
      </div>
      }
    </div>
    <div class="w-full md:w-[50%]">
      <label
        class="text-muted font-medium dark:text-[#A5A6A8]"
        for="mobilePhone"
      >
        {{ "Shared.Phone" | translate }}
      </label>
      <ngx-intl-tel-input
        inputId="mobilePhone"
        [cssClass]="
          'shared-input mt-2 dark:bg-second-dark dark:border-border-dark w-full'
        "
        #phoneInput
        [preferredCountries]="[]"
        [selectedCountryISO]="CountryISO.Italy"
        [enableAutoCountrySelect]="false"
        [enablePlaceholder]="true"
        [searchCountryFlag]="true"
        [searchCountryField]="[
          SearchCountryField.Name,
          SearchCountryField.DialCode
        ]"
        [separateDialCode]="true"
        formControlName="mobilePhone"
        (change)="onPhoneChange()"
      ></ngx-intl-tel-input>
      @if ( isSubmitted && getControl('mobilePhone'
      ).hasError('validatePhoneNumber') ) {
      <small class="text-[#dc3545] font-medium">
        {{ "Errors.Number_Error" | translate }}
      </small>
      }
    </div>
  </div>

  <div class="flex flex-col gap-4 justify-between w-full mt-3">
    <label class="text-muted font-medium dark:text-[#A5A6A8]" for="message"
      >{{ "Contact.Message" | translate }}
    </label>
    <textarea
      rows="5"
      name=""
      id="message"
      class="shared-input dark:text-white dark:bg-primary-dark mb-0"
      [ngClass]="{
        'is-invalid': isSubmitted && getControl('emailBody').invalid,
        'is-valid': isSubmitted && getControl('emailBody').valid
      }"
      placeholder="{{ 'Contact.Message' | translate }} "
      formControlName="emailBody"
    ></textarea>
    @if(isSubmitted && getControl('emailBody').invalid){
    <div class="text-danger mt-1">
      @if (getControl('emailBody').errors?.['minlength']) {
      <small>{{ "Errors.Minlength_Error" | translate }}</small>
      }
    </div>
    }
  </div>

  <div class="flex justify-end mt-2">
    <div class="w-full lg:w-[30%] flex gap-4">
      <button
        type="button"
        class="btn-submit py-2 bg-white text-[#6B7280] px-3 border-1 border-[#eaeaea]"
        (click)="resetForm()"
      >
        {{ "Feedback.Clear" | translate }}
      </button>
      <button type="button" class="btn-submit py-2" (click)="onSubmit()">
        {{ "Feedback.Send" | translate }}
      </button>
    </div>
  </div>
</form>

@if(submittedForm){
<app-submitted-form-popup (close)="submittedForm = false" />
} @if (showValidationToast) {
<app-validation-toast />
}
